import type { ChangeEvent, JSX, RefObject } from "react";

interface HiddenFileInputProps {
  inputRef: RefObject<HTMLInputElement | null>;
  accept: string;
  onFileChosen: (event: ChangeEvent<HTMLInputElement>) => void;
}

/**
 * Скрытый файловый ввод: примитив дизайн-системы, через который экран открывает
 * системный диалог выбора файла. Видимая часть — обычная кнопка экрана, она
 * дёргает этот ввод через переданную ссылку; сам ввод не показывается, потому
 * что его собственный вид не поддаётся оформлению и разошёлся бы с кнопками
 * дизайн-системы.
 */
export function HiddenFileInput(props: HiddenFileInputProps): JSX.Element {
  return (
    <input
      ref={props.inputRef}
      type="file"
      accept={props.accept}
      hidden
      onChange={props.onFileChosen}
    />
  );
}
